<template>
    <form @submit.prevent="onRating()">
        <p class="mb-2 font-weight-bold">Deja tu reseña y califica nuestros servicios</p>
        <v-app class="mb-2">
            <v-rating background-color="warning lighten-1" color="warning" length="5" size="45" v-model="form.rating"></v-rating>
        </v-app>
        <textarea v-model="form.comment" class="form-control mb-3" placeholder="Escribe tu reseña aquí..." rows="4"></textarea>
        <button type="submit" class="btn btn-dark w-100" :disabled="!form.comment">Enviar</button>
    </form>
</template>
<script>
export default {
  data () {
    return {
      result: -1,
      form: {
        rating: 0
      },
      API: process.env.API_RATING
    }
  },
  methods: {
    onRating: function () {
      this.result = -2
      setTimeout(() => {
        this.$axios({
          url: this.API,
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          data: this.form
        })
          .then((resp) => {
            this.form = {
              rating: 0
            }
            this.result = 0
            this.$swal({ icon: 'success', title: resp.data.message, position: 'top-end', showConfirmButton: false, timer: 3000 })
          })
          .catch((er) => {
            this.result = 0
          })
      }, 1000)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Rating.vue